import { useEffect } from "react";

interface PageVisibilityListenerProps {
  onVisible: () => void;
}

const PageVisibilityListener: React.FC<PageVisibilityListenerProps> = ({ onVisible }) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        onVisible();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onVisible]);

  return null; // This component doesn't render anything
};

export default PageVisibilityListener;